export default "__VITE_ASSET__CDKBntFk__$_?nuxt_component=async&nuxt_component_name=SvgoUserKycCardThird&nuxt_component_export=default__"